import { Home, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useOptionalAuth } from "@/contexts/AuthContext";

/**
 * Log out for a signed-in operator on the demo review pages (/article*,
 * /feather*). Those pages hide the header's Home and Log out so the preview
 * looks like what an applicant sees, which left the operator no way to sign
 * out. Renders nothing when nobody is signed in.
 */
export function DemoSignOutButton() {
  const { user, signOut } = useOptionalAuth();
  const navigate = useNavigate();
  if (!user) return null;
  return (
    <button
      type="button"
      className="demo-sign-out"
      onClick={async () => {
        await signOut();
        navigate("/login");
      }}
    >
      <LogOut className="h-4 w-4" aria-hidden="true" />
      Log out
    </button>
  );
}

/**
 * Home for a signed-in operator on the Feather demo pages: back to the
 * dashboard, where the staff banner and the org switcher are (the demo pages
 * hide both, Juan 2026-10-14). Renders nothing when nobody is signed in.
 */
export function DemoHomeButton() {
  const { user } = useOptionalAuth();
  const navigate = useNavigate();
  if (!user) return null;
  return (
    <button type="button" className="demo-sign-out" onClick={() => navigate("/")}>
      <Home className="h-4 w-4" aria-hidden="true" />
      Home
    </button>
  );
}
